import { tasksApi } from "@/services/api"

export default {
  namespaced: true,
  state: {
    today: [],
    week: [],
    month: [],
    loading: false,
  },
  mutations: {
    SET_LOADING(state, val) { state.loading = val },
    SET_TASKS(state, groups) {
      state.today = groups.today || []
      state.week = groups.week || []
      state.month = groups.month || []
    },
    ADD_TASK(state, task) {
      state[task.horizon].push(task)
    },
    UPDATE_TASK(state, updated) {
      for (const h of ["today", "week", "month"]) {
        const idx = state[h].findIndex((t) => t.id === updated.id)
        if (idx !== -1) { state[h].splice(idx, 1, updated); break }
      }
    },
    REMOVE_TASK(state, { id, horizon }) {
      state[horizon] = state[horizon].filter((t) => t.id !== id)
    },
  },
  actions: {
    setFromDashboard({ commit }, taskGroups) {
      commit("SET_TASKS", taskGroups)
    },
    async createTask({ commit }, data) {
      const { data: task } = await tasksApi.create(data)
      commit("ADD_TASK", task)
      return task
    },
    async toggle({ commit }, taskId) {
      const { data } = await tasksApi.toggle(taskId)
      commit("UPDATE_TASK", data)
    },
    async removeTask({ commit }, task) {
      await tasksApi.remove(task.id)
      commit("REMOVE_TASK", { id: task.id, horizon: task.horizon })
    },
  },
}
